import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import IconButton from '@material-ui/core/IconButton';
import CorrectIcon from '@material-ui/icons/Done';
import IncorrectIcon from '@material-ui/icons/Clear';
import { staticsUrl } from '../../config';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 550,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
    },
  },
  sentences: {
    '& div': {
      textAlign: 'center',
      border: '2px solid ' + theme.palette.primary.light,
      borderRadius: '0.5em',
      margin: '0.2em 0',
      padding: '0.5em 0.5em',
      cursor: 'pointer',
      position: 'relative',
      '& svg': {
        position: 'absolute',
        top: 4,
        right: 4,
        background: '#fff',
        borderRadius: '50%',
      },
    },
  },
  correct: {
    color: theme.palette.success.main,
  },
  incorrect: {
    color: theme.palette.error.main,
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 10,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 500px)': {
    sentences: {
      '& div': {
        '& svg': {
          top: 2,
          right: 2,
        },
      },
    },
  }
}));

let active = true;
let timeout = 0;

function ListenAndUnderstand(props) {
  const classes = useStyles();
  const [ no, setNo ] = useState(0);
  const [ finished, setFinished ] = useState(false);
  const [ clicked, setClicked ] = useState(false);
  const [ sentences, setSentences ] = useState([]);
  const { exercise, startStats, finishExercise, action, type, close } = props.exerciseProps;
  const len = exercise.length;

  useEffect(() => {
    init();
    return () => {
      clearTimeout(timeout);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!exercise) return;
    prepareSentences();
    // eslint-disable-next-line
  }, [no]);

  const init = () => {
    startStats(type);
    setFinished(false);
    prepareSentences();
  }


  const play = () => {
    const url = exercise[no].soundUrl;
    action();
    props.media.play(staticsUrl + url);
  }

  const next = () => {
    if (no < len - 1) {
      setNo(no + 1);
    } else {
      if (no === len - 1) finish();
    }
  }

  const correct = () => {
    props.media.success();
    timeout = setTimeout(() => {
      setClicked(false);
      next();
      active = true;
    }, 1500);
  }

  const incorrect = () => {
    props.media.failure();
    timeout = setTimeout(() => {
      setClicked(false);
      active = true;
    }, 1500);
  }

  const finish = () => {
    finishExercise();
    setFinished(true);
    props.media.finish();
  }

  const checkAnswer = (sent, idx) => {
    action();
    if (!active) return;
    active = false;
    setClicked(idx);
    if (sent.correct) { 
      correct();
    } else {
      incorrect();
    }
  }

  const randNo = (max) => {
    return Math.round(Math.random() * max);
  }

  const prepareSentences = () => {
    const sen = [ ...exercise ];
    const ok = { ...sen.splice(no, 1)[0],correct: true };
    const arr = [ ok ];
    [ 0, 1, 2].forEach(_ => arr.push(sen.splice(randNo(sen.length - 1), 1)[0]));
    setSentences(shuffle(arr));
    play();
  }

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Wybierz zdanie pasujące do tekstu mówionego.</h3>
        <div className={classes.sentences}>
          {sentences.map((sent, idx) => <div key={idx} onClick={() => checkAnswer(sent, idx)}>
            {sent.translation}
            {clicked === idx && sent.correct && <CorrectIcon className={classes.correct} />}
            {clicked === idx && !sent.correct && <IncorrectIcon className={classes.incorrect} />}
          </div>)}
        </div>
        <div className={classes.action}>
          <span>{no + 1}/{len}</span>
        </div>
        <div className={classes.action}>
          {!finished && <IconButton onClick={play}><VolumeUpIcon fontSize="large" color="primary"/></IconButton>}
          {finished && <Button variant="outlined" color="secondary" onClick={close}>Zamknij</Button>}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;
  while (0 !== currentIndex) {
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }
  return array;
}

export default connect(mapStateToProps)(ListenAndUnderstand);